import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import customTheme from "./styles/customTheme";
import {ChakraProvider} from "@chakra-ui/react";
import ErrorBoundary from "./helpers/ErrorBoundary";
import Fonts from "./styles/Fonts";

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
                <Fonts />
                <ChakraProvider theme={customTheme}>
                    <ErrorBoundary>
                        <App/>
                    </ErrorBoundary>
                </ChakraProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
